<template>
  <div class="copytoDetail">
    <div class="todolist">
      <v-table
      :row-click-color="'rgba(239,239,239,0.5)'"
      :row-click="selectRow"
      style="width:100%"
      :is-horizontal-resize="true"
      :columns="copyColumns"
      :table-data="copyData"
      :show-vertical-border="false"
      ></v-table>
      <div class="pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="totalCount"
                      :pageIndex="pageNumber" :page-size="pageSize"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  //vuex
  //通信总线
  import Bus from 'common/js/bus.js';
  export default {
    name: "copytoDetail",
    data () {
      return {
        pageNumber:1,
        pageSize: 10,
        totalCount: null,
        copyData: []
      }
    },
    props: {
      currentCopyto: {}
    },
    computed: {
      copyColumns () {
        return [
          {
            field: 'custome', title: '序号', width: 150, titleAlign: 'center', columnAlign: 'center',
            formatter:  (rowData, rowIndex, pagingIndex, field) =>{
              return (this.pageSize * (this.pageNumber - 1)) + rowIndex + 1
            }, isFrozen: true, isResize: false
          },
          {
            field: 'processInstName',
            title: '标题',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getLinkedText
          },
          {
            field: 'time',
            title: '创建时间',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          }
        ]
      },
    },
    methods: {
      pageSizeChange (e) {
        this.pageNumber = 1
        this.pageSize = e
        this.getCopyto(this.currentCopyto)
      },
      pageChange (e) {
        this.pageNumber = e
        this.getCopyto(this.currentCopyto)
      },
      //生成表格高亮标签
      getLinkedText(rowData, rowIndex, pagingIndex, field) {
        return `<span class="highlightLink">${rowData[field]}</span>`;
      },
      selectRow (rowIndex,rowData) {
        console.log(rowData);
        this.$emit('detailSelectRow',{title: rowData.processInstName, url: rowData.url})
      },
      async getCopyto (e) {
        let copyData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getCarbonCopyMsgDetailForUser?" + this.$qs.stringify({
          pageNum: this.pageNumber,
          pageSize: this.pageSize,
          sysname: e.processChName
        }))
        console.log(copyData);
        this.copyData = copyData.data.data[0].list
        this.totalCount = copyData.data.data[0].total
      }
    },
    mounted() {
      this.getCopyto(this.currentCopyto)
    }
  }
</script>

<style lang="stylus" scoped>
  .todolist
    padding 0 15px
    margin-top 20px
    /*border 1px solid #00f*/

    table
      margin 20px
</style>


// WEBPACK FOOTER //
// src/components/todo/copytoDetail.vue